import permissions from "app/permissions";
import {
  BooleanField,
  Datagrid,
  DateField,
  FunctionField,
  ListContextProvider,
  TextField,
  useList,
  useRecordContext,
} from "react-admin";
import { Box } from "@mui/material";
import SecuredComponent from "server/security/SecuredComponent";
import UpdateAccreditationExpiryDateDialog from "./UpdateAccreditationExpiryDateDialog";
import AddSpecializationsDialog from "./AddSpecializationsDialog";

const SpecializationsExpanded = () => {
  const record = useRecordContext();
  const data = (record?.specializations ?? []).map(s => ({ ...s, id: s.specializationId }));
  const listContext = useList({ data });

  if (!record?.specializations?.length) return null;

  return (
    <ListContextProvider value={listContext}>
      <Datagrid
        rowClick={false}
        bulkActionButtons={false}
        sx={{
          "& .RaDatagrid-headerCell": {
            textAlign: "left",
          },
        }}
      >
        <TextField
          source="specializationNameBg"
          label="Специалност (БГ)"
        />
        <TextField
          source="specializationNameEn"
          label="Специалност (EN)"
        />
        <DateField
          source="accreditationExpiryDate"
          label="Изтичане на акредитация"
          locales="bg-BG"
        />
        <BooleanField
          source="isExpired"
          label="Изтекла акредитация"
        />
        <FunctionField
          render={rec => (
            <SecuredComponent permission={permissions.canManageSpecialistsTrainingBuildings}>
              <UpdateAccreditationExpiryDateDialog
                buildingId={record.buildingId}
                specializationId={rec?.specializationId}
              />
            </SecuredComponent>
          )}
        />
      </Datagrid>
      <SecuredComponent permission={permissions.canManageSpecialistsTrainingBuildings}>
        <Box sx={{ display: "flex", justifyContent: "flex-start", mb: 1 }}>
          <AddSpecializationsDialog
            buildingId={record.buildingId}
            specializations={record.specializations}
          />
        </Box>
      </SecuredComponent>
    </ListContextProvider>
  );
};

export default SpecializationsExpanded;
